import { createFileRoute, useParams } from '@tanstack/react-router'

import { PlatformChangeContractStatusPage } from '../../../../../components/pages/backoffice/platform/platform-change-contract-status-page/platform-change-contract-status-page.tsx'
import { InviteToLoginPage } from '../../../../../components/templates/invite-to-login/invite-to-login-page.tsx'
import { useManagedByOrusOnlyPermissions } from '../../../../../lib/use-managed-by-orus-only-permissions.ts'
import { usePermissions } from '../../../../../lib/use-permissions.ts'

function RouteComponent() {
  const { subscriptionId } = useParams({ from: '/bo/contracts/$subscriptionId/status' })
  const { hasPermission } = usePermissions()
  const { hasManagedByOrusScopedPermission } = useManagedByOrusOnlyPermissions({
    subscriptionId,
    managedByOrusOnlyPermission: 'contract.update.managedByOrusOnly',
  })
  if (!hasPermission('contract.update') && !hasManagedByOrusScopedPermission) return <InviteToLoginPage />
  return <PlatformChangeContractStatusPage />
}

export const Route = createFileRoute('/bo/contracts/$subscriptionId/status')({
  component: RouteComponent,
})
